import { RouteObject } from 'react-router'

import { ROUTES } from '@/common/constants/routes'
import { AuthenticatedLayout } from '@/common/layouts/AuthenticatedLayout'
import { RegistersLayout } from '@/common/layouts/RegistersLayout'
import Upload from './pages/Upload'
import Users from './pages/Users'

export const RegistersRoutes: RouteObject[] = [
  {
    element: <AuthenticatedLayout />,
    children: [
      {
        element: <RegistersLayout />,
        children: [
          { path: ROUTES.REGISTERS.USERS, element: <Users /> },
          { path: ROUTES.REGISTERS.FILES, element: <Upload /> },
        ],
      },
    ],
  },
]
